import { MutationTree } from 'vuex'
import { UserState } from './state'
import {
  SET_AVATAR,
  SET_USER_DATA,
  SET_USER_EXTRA_DATA,
  SET_CREDITS,
  SET_USER_NOTIFICATION_CENTER_DATA,
  SET_USER_NOTIFICATION_CENTER_LOADING_STATE,
  CLEAR_NOTIFICATION_CENTER_DATA,
  TRANSFER_ROGUE_CLASSIFIED
} from './mutation-types'
import {
  UserCredits,
  UserNotificationsCenter,
  UserExtrasResult,
  AuthUserResult
} from '~/models/user/types'
import { Pagination } from '~/models/search/types'
import { NotificationEvent } from '~/models/notification-center/types'
import { DEFAULT_NUMBER_OF_RESULTS_PER_PAGE } from '~/constants/search/defaults'

export default {
  [SET_USER_DATA](state, userData: AuthUserResult) {
    state.username = userData.username
    state.name = userData.name
    state.avatar = userData.avatar
    state.id = userData.id
    state.permissions = userData.permissions
    state.properties = userData.properties
    state.type = userData.type
    state.username = userData.username
    state.location = userData.location
    state.credits = userData.credits
    state.featureToggles = userData.featureToggles
    state.referenceCode = userData.referenceCode
    state.isPayingUser = userData.isPayingUser
    state.accessToggles = userData.accessToggles
    state.hasPublicDealers = userData.hasPublicDealers
    state.subscription = userData.subscription
    state.stripeSubscription = userData.stripeSubscription
    state.externalIds = userData.externalIds
    state.sdmu = userData.sdmu
    state.hasCompleteProfile = userData.hasCompleteProfile
    if (userData.dealerIds) {
      state.dealerIds = userData.dealerIds
    }
  },
  [SET_AVATAR](state, avatar: string) {
    state.avatar = avatar
  },
  [SET_USER_EXTRA_DATA](state, userExtraData: UserExtrasResult) {
    state.unreadNotifications = userExtraData.unreadNotifications
    state.unreadMessages = userExtraData.unreadMessages
    state.unreadParkingNotifications = userExtraData.unreadParkingNotifications
    state.unreadTradesNotifications = userExtraData.unreadTradesNotifications
    state.myClassifieds = userExtraData.myClassifieds
    state.xmlIssues = userExtraData.xmlIssues
    state.invoicesCount = userExtraData.invoicesCount
    state.outletsCount = userExtraData.outletsCount
    state.rogueClassifiedsCount = userExtraData.rogueClassifiedsCount
    state.rogueRequirements = userExtraData.rogueRequirements
    state.auditRequestsCount = userExtraData.auditRequestsCount
  },
  [SET_CREDITS](state, credits: UserCredits) {
    state.credits = credits
  },
  [SET_USER_NOTIFICATION_CENTER_DATA](
    state,
    notificationsCenterData: UserNotificationsCenter
  ) {
    state.notificationsCenter = {
      ...state.notificationsCenter,
      ...notificationsCenterData
    }
  },
  [TRANSFER_ROGUE_CLASSIFIED](state) {
    if (state.rogueClassifiedsCount && state.rogueClassifiedsCount > 0)
      state.rogueClassifiedsCount = state.rogueClassifiedsCount - 1
  },
  [CLEAR_NOTIFICATION_CENTER_DATA](state) {
    state.notificationsCenter = {
      loading: true,
      notifications: {
        pagination: {
          perPage: DEFAULT_NUMBER_OF_RESULTS_PER_PAGE,
          total: 0
        } as Pagination,
        rows: [] as Array<NotificationEvent>
      },
      notificationTypes: []
    }
  },

  [SET_USER_NOTIFICATION_CENTER_LOADING_STATE](state, loading: boolean) {
    state.notificationsCenter.loading = loading
  }
} as MutationTree<UserState>
